import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
var _excluded = ["type", "duration", "target", "clearable"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext, useMemo, useState } from 'react';
import { uniqueId, noop } from 'lodash';
export var ToastContext = /*#__PURE__*/createContext({
  toasts: [],
  addToast: noop
});
export function ToastProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var value = useMemo(function () {
    return {
      toasts: toasts,
      addToast: function addToast(_ref2) {
        var type = _ref2.type,
            duration = _ref2.duration,
            _ref2$target = _ref2.target,
            target = _ref2$target === void 0 ? 'main' : _ref2$target,
            clearable = _ref2.clearable,
            props = _objectWithoutProperties(_ref2, _excluded);

        var uuid = uniqueId();

        var newToast = _objectSpread(_objectSpread({}, props), {}, {
          id: uuid,
          type: type,
          target: target,
          duration: duration,
          remove: function remove() {
            return setToasts(function (toasts) {
              return _filterInstanceProperty(toasts).call(toasts, function (toast) {
                return toast.id !== uuid;
              });
            });
          },
          clearable: clearable
        });

        setToasts(function (toasts) {
          var _context;

          return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(toasts), [newToast]);
        });
      }
    };
  }, [toasts]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: value
  }, children);
}
export function useToast() {
  return useContext(ToastContext);
}